import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'src/app/_services/notification.service';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
  selector: 'app-forgot-pass-dialog',
  templateUrl: './forgot-pass-dialog.component.html',
  styleUrls: ['./forgot-pass-dialog.component.css']
})
export class ForgotPassDialogComponent implements OnInit {
  model: any = {};
  username: string;
  constructor(public dialogRef: MatDialogRef<ForgotPassDialogComponent>,
    private authService: AuthService,
    private notify: NotificationService) { }

  ngOnInit() {
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  send() {
    this.model.username = this.username;
    this.authService.sendRequestForChangePassword(this.model).subscribe(() => {
      this.notify.message('Poslat zahtev za izmenu lozinke, proverite E-MAIL sanduče');
    }, error => {
      this.notify.error(error);
    }, () => {
      this.dialogRef.close();
    });
  }

}
